<template>
  <footer>
  	
  	<ul class="footer-list">
      <router-link v-for="(item,index) in list" :to='{path: item.path}' tag="li" @click.native="countNumber(1,(index+1))">
        <span :class="{active:index==num}"></span>
        {{item.title}}
      </router-link>
      

  	</ul>
  </footer>
  

</template>

<script>
export default {
 props: {
    num:{
       type:Number,
       default:0
     }   
  },
  name: 'footerBar',
  data () {
    return {
      list:[
          {
            "title":"常用服务",
            "path":"/commonSec"

          },
           {
            "title":"自助查询",
            "path":"/selfCheck"

          },
           {
            "title":"自助递交",
            "path":"/selfPush"

          },
           {
            "title":"人工服务",
            "path":"/service"

          },

      ]
      
    }
  }
}
</script>


<style scoped>
footer{height: 1.28rem;background: #fafafa;position: fixed;bottom: 0;width: 100%;}
.footer-list{height: 1.28rem;font-size: 0.2rem;overflow:hidden;background: #fafafa}
.footer-list li {width:0.9rem;text-align: center;float: left;margin-left: 0.77rem;margin-top: 0.18rem;font-size: 0.2rem}
.footer-list li span{margin-left: 0.17rem;margin-bottom: 0.2rem}
.footer-list li:nth-of-type(1) span{width: 0.5rem;background: url(../../assets/changyong-1.png) no-repeat; background-size: cover;display:block;height: 0.56rem;margin-bottom: 0.15rem}
.footer-list li:nth-of-type(2) span{width: 0.5rem;background: url(../../assets/zizhu.png) no-repeat; background-size: cover;display:block;height: 0.5rem}
.footer-list li:nth-of-type(3) span{width: 0.48rem;height: 0.52rem;background: url(../../assets/dijiao.png) no-repeat; background-size: cover;;display:block;margin-left: 0.18rem}
.footer-list li:nth-of-type(4) span{width: 0.5rem;background: url(../../assets/rengong.png) no-repeat; background-size: cover;;display:block;height: 0.5rem}

.footer-list li:nth-of-type(1) .active{width: 0.5rem;background: url(../../assets/changyong.png) no-repeat;  background-size: cover;display:block;height: 0.56rem;margin-bottom: 0.15rem}
.footer-list li:nth-of-type(2) .active{background: url(../../assets/zizhu-active.png) no-repeat;width: 0.5rem; background-size: cover;display:block;height: 0.5rem }
.footer-list li:nth-of-type(3) .active{background: url(../../assets/dijiao-active.png) no-repeat;width: 0.48rem;height: 0.52rem; background-size: cover;;display:block;margin-left: 0.18rem }
.footer-list li:nth-of-type(4) .active{background: url(../../assets/rengong-active.png) no-repeat;width: 0.5rem; background-size: cover;;display:block;height: 0.5rem}

</style>



// WEBPACK FOOTER //
// src/components/base/footer.vue